var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"px-1 py-2 text-sm text-gray-600 bg-gray-200 hover:bg-red-600 hover:text-white focus:outline-none",on:{"click":_vm.signOut}},[_vm._v("Sign-out")])])}
var staticRenderFns = []

export { render, staticRenderFns }